import { User } from '@/types/user';

const APP_ID = '6478343472';
const META_TAG_NAME = 'apple-itunes-app';

/**
 * Handles the Apple Smart App Banner meta tag
 * Adds or removes the meta tag based on route configuration and user experiments
 *
 * @param shouldShowBanner - Whether the current route should show the app banner
 * @param user - The current user object (optional)
 */
export function handleAppMetaTag(shouldShowBanner: boolean, user?: User | null): void {
    const existingMeta = document.querySelector(`meta[name="${META_TAG_NAME}"]`);
    const hasChallengeExperiment = user?.experiments?.steven_bartlett_challenge_experiment === 1;

    // Remove meta tag if user has the challenge experiment
    if (existingMeta && hasChallengeExperiment) {
        existingMeta.remove();
        return;
    }

    // Add meta tag if route requires banner, no existing tag, and user doesn't have challenge
    if (shouldShowBanner && !existingMeta && !hasChallengeExperiment) {
        const meta = document.createElement('meta');
        meta.setAttribute('name', META_TAG_NAME);
        meta.setAttribute('content', `app-id=${APP_ID}`);
        document.head.appendChild(meta);
        return;
    }

    // Remove meta tag if route doesn't require banner and tag exists
    if (!shouldShowBanner && existingMeta) {
        existingMeta.remove();
    }
}

/**
 * Removes the Apple Smart App Banner meta tag
 */
export function removeAppMetaTag(): void {
    const existingMeta = document.querySelector(`meta[name="${META_TAG_NAME}"]`);
    if (existingMeta) {
        existingMeta.remove();
    }
}
